import {Component, EventEmitter, Input, Output} from "@angular/core";
import {WatchService} from "../../services/watch.service";
import {DEF_INPUT_SIZE} from "../../enums/enums";
import {JP} from "../../helpers/jp";
import * as _ from "underscore";

@Component({
  selector: "nv-checkbox",
  templateUrl: "./nv-checkbox.component.html"
})


export class NvCheckboxComponent {
  private _label: string;
  private _size: number;
  private _inverted: boolean = false;
  private _document: any;
  private _pointer: string;

  public model:boolean;

  @Input() set document(v: any) {
    this._document = v;
    this.updateModel();
  };

  @Input() set pointer(v: string) {
    this._pointer = v;
    this.updateModel();
  };

  @Input() mini: boolean = false;
  @Input() set label(v: string) { this._label = v; }
  @Input() set size(v: number) { this._size = v; }
  @Input() set inverted(v: boolean)
  {
    this._inverted = v;
    this.updateModel();
  }

  get document() { return this._document; }
  get pointer() { return this._pointer; }
  get label(): string { return this._label || "NO LABEL"; }
  get size(): number { return this._size || DEF_INPUT_SIZE; }
  get inverted():boolean { return this._inverted}

  @Output() update = new EventEmitter<boolean>();


  constructor(private watchService: WatchService) {
  }


  onChange(v: boolean) {
    this.update.emit(v);
    JP.set(this.document, this.pointer, this.inverted ? !this.model : this.model);
    this.watchService.notify();
  }

  private updateModel() {
    if (_.isUndefined(this.document) || _.isUndefined(this.pointer)) {
      return;
    }

    if (!JP.has(this.document, this.pointer)) {
      JP.set(this.document, this.pointer, false);
    }

    this.model = this.inverted ? !JP.get(this.document, this.pointer) : JP.get(this.document, this.pointer);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-checkbox/nv-checkbox.component.ts